import { signOut } from 'firebase/auth';

import { auth } from '@/shared';

export async function signOutSession(): Promise<void> {
  await signOut(auth);
}
